import createBrowserHistory from 'history/createBrowserHistory';
import { create } from 'mobx-persist';
import { Provider } from 'mobx-react';
import { RouterStore, syncHistoryWithStore } from 'mobx-react-router';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import App from './App';
import DataStore from './containers/store/DataStore';
import registerServiceWorker from './registerServiceWorker';
import 'intl';
import 'intl/locale-data/jsonp/en';
import { inIframe } from './utils/browser';
import 'date-input-polyfill';
import { GA_KEY } from './constants';
import { StorageType } from './enums';

declare var gtag: Function;

if (GA_KEY && window.location === window.parent.location) {
  gtag('config', 'GA_KEY');
}

const routing = new RouterStore();
const dataStore = new DataStore(routing);

const stores = {
  routing,
  dataStore
};

const updateLangAttribute = locale => {
  const localeString = locale;
  const regexp = /\b(\w{2,3})-/gi;
  const match = regexp.exec(localeString);

  document.querySelector('html[lang]').setAttribute('lang', match[1]);
};

const render = locale => {
  updateLangAttribute(locale);
  const browserHistory = createBrowserHistory({ basename: `/${locale}` });
  const history = syncHistoryWithStore(browserHistory, routing);
  if (inIframe()) {
    history.listen((location, action) => {
      sessionStorage.setItem(
        StorageType.ACTIVE_SESSION_PATH,
        location.pathname
      );
    });
  }

  ReactDOM.render(
    <Provider {...stores}>
      <Router history={history}>
        <App />
      </Router>
    </Provider>,
    document.getElementById('root') as HTMLElement
  );
};

const persistStores = async () => {
  const hydrate = create();
  await hydrate('dataStore', stores.dataStore);
  await dataStore.setLocale();
  render(dataStore.locale);
  dataStore.redirectToLatestSession();
};

registerServiceWorker();
persistStores();



// WEBPACK FOOTER //
// ./src/index.tsx